export interface PollResult { id: string; question: string; options: string[]; votes: number[]; closedAt: string; }
export function pollResultCsv(poll: PollResult): string {
  const cell = (v: unknown) => {
    let text = String(v ?? '');
    if (/^\s*[=+@\-]/u.test(text)) text = "'" + text;
    return '"' + text.replace(/"/g, '""') + '"';
  };
  const total = poll.votes.reduce((sum, n) => sum + n, 0);
  const rows: unknown[][] = [['poll_id', 'question', 'option', 'votes', 'total_votes', 'closed_at']];
  poll.options.forEach((option, index) => rows.push([poll.id, poll.question, option, poll.votes[index] || 0, total, poll.closedAt]));
  return '\uFEFF' + rows.map(row => row.map(cell).join(',')).join('\r\n');
}
export function validPollVote(optionIndex: number, optionCount: number, identity: string, previous: Set<string>): boolean {
  return Number.isInteger(optionIndex) && optionIndex >= 0 && optionIndex < optionCount && identity.length > 0 && !previous.has(identity);
}
